document.addEventListener('DOMContentLoaded', () => {
    const tabsContainer = document.querySelector('.business-popular__tabs');
    if (!tabsContainer) {
        return;
    }

    const tabs = tabsContainer.querySelectorAll('.business-popular__tab');
    if (!tabs.length) {
        return;
    }

    const panels = document.querySelectorAll('[data-business-popular-panel]');
    const allLink = document.querySelector('[data-business-popular-all]');

    tabsContainer.addEventListener('click', (event) => {
        const tab = event.target.closest('.business-popular__tab');
        if (!tab || !tabsContainer.contains(tab)) {
            return;
        }

        const targetPanel = tab.dataset.businessPopularTab;
        if (!targetPanel) {
            return;
        }

        tabs.forEach((item) => {
            item.classList.remove('business-popular__tab--active');
            item.setAttribute('aria-selected', 'false');
        });

        panels.forEach((panel) => {
            const isActive = panel.dataset.businessPopularPanel === targetPanel;

            panel.hidden = !isActive;
            panel.classList.toggle('business-popular__cards--active', isActive);
        });

        tab.classList.add('business-popular__tab--active');
        tab.setAttribute('aria-selected', 'true');

        if (allLink && tab.dataset.allUrl) {
            allLink.href = tab.dataset.allUrl;
        }
    });
});
